import { useMutation } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export function useRequestPasswordResetMutation() {
  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.authPasswordResetCreate>[0]) =>
      SSF.api.authPasswordResetCreate(variables),
  });
}

export function useConfirmPasswordResetMutation() {
  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.authPasswordResetConfirmCreate>[0]) =>
      SSF.api.authPasswordResetConfirmCreate(variables),
  });
}
